import { createSlice } from "@reduxjs/toolkit";
import { DashboardInitialStatus } from "../../../types/dashboard/dashboard";
import { getAllDashboardDataAsync } from "./dashboardApi";

const initialState: DashboardInitialStatus<any> = {
  loading: false,
  manageLoading: false,
  dashboardCardData: null,
  countData: 0,
};

const dashboardSlice = createSlice({
  name: "admin-dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllDashboardDataAsync.pending, (state) => {
      state.loading = true;
    });
    builder
      .addCase(getAllDashboardDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardCardData = action.payload.data;
        state.countData = action.payload.length;
      })
      .addCase(getAllDashboardDataAsync.rejected, (state) => {
        state.loading = false;
        state.dashboardCardData = null;
        state.countData = 0;
      });
  },
});

export default dashboardSlice;
